import angular from 'angular';
import uiRouter from 'angular-ui-router';
import incompletedocumentationComponent from './incompletedocumentation.component';

let incompletedocumentationModule = angular.module('incompletedocumentation', [
  uiRouter
])

.component('incompletedocumentation', incompletedocumentationComponent);

export default incompletedocumentationModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/incompletedocumentation/incompletedocumentation.js